module.exports = __webpack_public_path__ + "img/about_bg.b96b0150.jpg";